import(/* webpackMode: "eager" */ "/app_next/public/assets/uma.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app_next/src/app/layoutTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app_next/src/shared/RefrescarTokenDeSesion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CallingCard"] */ "/app_next/src/storybook/components/clientComponents/CallingCard/CallingCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PendingCallsProvider"] */ "/app_next/src/storybook/components/clientComponents/CallingCard/PendingCallsContext.tsx");
